import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { ICRUDOptions } from '@phx-erp/shared';
import { BaseListService } from '../../../@core/services/base-list.service';
import { I18nService } from '../../../@core/services/i18n/i18n.service';
import { SystemService } from '../../../@core/services/system.service';
import { DELETE_PRODUCT_VARIANT_TO_FACET_VALUE, GET_PRODUCT_VARIANT_TO_FACET_VALUE, GET_PRODUCT_VARIANT_TO_FACET_VALUE_LIST, SAVE_PRODUCT_VARIANT_TO_FACET_VALUE } from '../../../data/definitions/product-variant-to-facette-value-link.definition';
import { BaseDataService } from '../../../data/services/base-data.service';
import { DataService } from '../../../data/services/data.service';
import { DeleteProductVariantToFacetValueLinkMutation, DeleteProductVariantToFacetValueLinkMutationVariables, DeletionResponse, GetProductVariantToFacetValueLinkListQuery, GetProductVariantToFacetValueLinkListQueryVariables, GetProductVariantToFacetValueLinkQuery, GetProductVariantToFacetValueLinkQueryVariables, ProductVariantToFacetValueLink, ProductVariantToFacetValueLinkInput, SaveProductVariantToFacetValueLinkMutation, SaveProductVariantToFacetValueLinkMutationVariables, SearchInput } from '../../../generated/generated-types';
import { AppInfoService } from '../../../shared/services/app-info.service';


@Injectable({
  providedIn: 'root'
})
export class ProductVariantToFacetValueLinkService extends BaseListService<ProductVariantToFacetValueLink> {

  constructor(
    private appInfo: AppInfoService,
    private dataService: DataService,
    private baseDataService: BaseDataService,
    private systemService: SystemService,
    private i18n: I18nService
  ) {
    super();
    // this.appInfo.ActiveViewName.next(i18n.translate(_("tenant.facet"))); // Ask about this Yuri Lima
  }
  //#region implementation
  getItems(searchInput?: SearchInput, o?: ICRUDOptions) {

    let fragment = GET_PRODUCT_VARIANT_TO_FACET_VALUE_LIST;

    if (o?.currentColumnConfig) {
      this.onlyKeepSelectedGraphQLNodesNew(fragment, o.currentColumnConfig.baseView, o.currentColumnConfig.columns);
    }
    let facet_list = this.baseDataService.query<GetProductVariantToFacetValueLinkListQuery, GetProductVariantToFacetValueLinkListQueryVariables>(
      fragment, {
      input: searchInput as SearchInput,
    });
    return facet_list;
  }

  // Get the item by id
  getItem(id: string) {
    return this.baseDataService.query<GetProductVariantToFacetValueLinkQuery, GetProductVariantToFacetValueLinkQueryVariables>(
      GET_PRODUCT_VARIANT_TO_FACET_VALUE, {
      id: id as string,
    });
  }

  // Get the item by id as stream (for subscriptions)[My guess Yuri Lima]
  getItemStream(id: string) {
    return this.getItem(id).mapStream(x => x.getProductVariantToFacetValueLink as ProductVariantToFacetValueLink);
  }

  // Get the item by id as promise
  async getItemData(id: string): Promise<ProductVariantToFacetValueLink> {
    let l = await lastValueFrom(this.getItem(id).single$);
    return l.getProductVariantToFacetValueLink as ProductVariantToFacetValueLink;
  }

  // Delete the item by id
  async deleteItem(id: string): Promise<DeletionResponse> {
    let res = await lastValueFrom(this.baseDataService.mutate<DeleteProductVariantToFacetValueLinkMutation, DeleteProductVariantToFacetValueLinkMutationVariables>(
      DELETE_PRODUCT_VARIANT_TO_FACET_VALUE, {
      id: id as string,
    }));
    return res.deleteProductVariantToFacetValueLink;
  }

  async saveItem(facet: ProductVariantToFacetValueLink | ProductVariantToFacetValueLinkInput) {

    // Validate the object before saving - it' necessary to validate the object before saving
    // Here we get facet as ProductVariantToFacetValueLinkInput and validate it as ProductVariantToFacetValueLinkInput (the same type) [my closest guess Yuri Lima]
    let validated = await this.systemService.validateObject<ProductVariantToFacetValueLinkInput>(facet, "ProductVariantToFacetValueLinkInput");

    // Save the object by calling the graphql mutation SAVE_PRODUCT_VARIANT_TO_FACET_VALUE_LINK and passing the validated object as input.
    // the response is of type SaveProductVariantToFacetValueLink.Mutation
    let saved = await lastValueFrom(this.baseDataService.mutate<SaveProductVariantToFacetValueLinkMutation, SaveProductVariantToFacetValueLinkMutationVariables>(
      SAVE_PRODUCT_VARIANT_TO_FACET_VALUE, {
      input: validated
    }));

    return saved.saveProductVariantToFacetValueLink as ProductVariantToFacetValueLink;
  }
  //#endregion
}
